const blockers = new Set<symbol>();

export function blockAutomaticAppReload() {
  const blocker = Symbol();
  blockers.add(blocker);
  return () => { blockers.delete(blocker); };
}

export function createAppReloadSafetyGuard() {
  const editedControls = new Set<Element>();
  const trackEdit = (event: Event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const control = target.closest('input, textarea, select, [contenteditable="true"]');
    if (control) editedControls.add(control);
  };
  document.addEventListener('input', trackEdit, true);
  document.addEventListener('change', trackEdit, true);

  return {
    canReload() {
      editedControls.forEach(control => {
        if (!document.documentElement.contains(control)) editedControls.delete(control);
      });
      if (blockers.size || editedControls.size || document.visibilityState === 'hidden') return false;

      const dialogs = document.querySelectorAll(
        '[role="dialog"], [aria-modal="true"], .ReactModal__Content--after-open, .MuiModal-root, [data-app-update-block]',
      );
      return !Array.from(dialogs).some(dialog => {
        if (dialog.closest('[hidden], [aria-hidden="true"]')) return false;
        const style = window.getComputedStyle(dialog);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    },
    dispose() {
      document.removeEventListener('input', trackEdit, true);
      document.removeEventListener('change', trackEdit, true);
      editedControls.clear();
    },
  };
}
